

import React, { useEffect, useState } from 'react';
import { FieldComponent } from '../../../types/FieldComponent';
import { compareText } from '../comparators/compareText';
import { Autocomplete, Popper, TextField } from '@mui/material';
import Box from '@mui/material/Box';
import { TextFilter } from '../filters/TextFilter';
import LargePopper from '../assets/LargePopper';

export const DatabaseTableTypeSelectField: FieldComponent<string, string[]> = ({
  intent,
  isActive,
  onChange,
  value,
  hasTooltip,
  disabled,
  mui,
  isMissing,
  forcedValue,
  isAddingNew,
  defaultValue,
}) => {
  const [currentState, setCurrentState] = useState<any>({
    value: null,
    send: false,
  });

  const [selectOptions, setSelectOptions] = useState<any>([
    {
      id: 1,
      label: 'Number',
      value: 'float',
    },
    {
      id: 2,
      label: 'String',
      value: 'string',
    },
    {
      id: 3,
      label: 'Rich Text',
      value: 'text',
    },
    {
      id: 4,
      label: 'Checkbox',
      value: 'boolean',
    },
    {
      id: 5,
      label: 'Driver',
      value: 'driver',
    },
  ]);

  /*useEffect(() => {
    if (defaultValue !== undefined) {
      setCurrentState({
        value: defaultValue,
        send: false,
      });
    }
  }, [defaultValue]);
*/
  useEffect(() => {
    if (currentState.send) {
      onChange(currentState.value?.value);
    }
  }, [currentState]);

  const handleOnChange = (event: any, value: any) => {
    setCurrentState({
      value: value,
      send: true,
    });
  };

  const CustomPopper = function (props: any) {
    return (
      <>
        <div>
          <Popper
            {...props}
            sx={{
              '& .MuiPaper-root': {
                boxShadow: '0 4px 10px -1px rgb(17 20 24 / 20%)',
              },
            }}
            style={{
              width: 'fit-content',
              maxWidth: '300px',
            }}
            placement="bottom-start"
          />
        </div>
      </>
    );
  };

  return (
    <>
      <Autocomplete
        fullWidth={true}
        PopperComponent={LargePopper}
        size="small"
        options={selectOptions}
        renderOption={(props: any, option: any) => {
          return (
            <Box
              component="li"
              sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
              {...props}
            >
              {option.label}
            </Box>
          );
        }}
        getOptionLabel={(option) => {
          return option?.label;
        }}
        isOptionEqualToValue={(option, value) => {
          if (!option?.value) return false;
          return option.value === value;
        }}
        value={currentState.value}
        renderInput={(params) => {
          return (
            <TextField
              {...params}
              size="small"
              InputLabelProps={{
                style: {
                  fontSize: 13,
                  paddingTop: 2,
                },
              }}
            />
          );
        }}
        onChange={(event, newValue) => {
          handleOnChange(event, newValue);
        }}
        disabled={disabled}
      />
    </>
  );
};

DatabaseTableTypeSelectField.includes = (query = [], value = '') => {
  if (query.length === 0 || value === null) return true;
  const valueLowercase = value.toLowerCase();
  return query.some((queryPart) =>
    valueLowercase.includes(queryPart.toLowerCase())
  );
};

DatabaseTableTypeSelectField.comparator = compareText;

DatabaseTableTypeSelectField.FilterRenderer = TextFilter;
